import { RootState } from 'core';
import { selectors as cartSelectors } from 'core/use-cases/cart';
import { getProductCartItem } from 'core/use-cases/helpers';
import { selectors as userSelectors } from 'core/use-cases/user';
import { useSelector } from 'react-redux';

import { editCatalogInfos } from '../helpers/edit-catalog-infos';

export const useCatalog = () => {
  const {
    data,
    status,
    queryOptions: { query = '' },
  } = useSelector((state: RootState) => state.catalog);

  const { data: cartData } = cartSelectors.useCartSelector();
  const itemAddCartError = userSelectors.useItemAddCartErrorSelector();

  const catalogData = editCatalogInfos({ data, cartData, itemAddCartError });

  return {
    data: catalogData,
    status,
    query,
  };
};
